import { createEffect, createSignal, JSX, onCleanup } from "solid-js";
import SideNav from "./SideNav";
import { TabKey } from "../types/ui";
import TemplatesModal from "./TemplatesModal";

export default function Layout(props: {
  active: TabKey;
  onSelect: (k: TabKey) => void;
  children: JSX.Element;
  sidebarExtra?: JSX.Element;
  onCaseInfoClick: () => void;
  banner?: JSX.Element;
}) {
  const [collapsed, setCollapsed] = createSignal(
    (localStorage.getItem("sidenav_collapsed") ?? "false") === "true"
  );
  const [showTemplates, setShowTemplates] = createSignal(false);
  createEffect(() => {
    const onOpen = () => setShowTemplates(true);
    window.addEventListener("open-templates", onOpen as any);
    onCleanup(() =>
      window.removeEventListener("open-templates", onOpen as any)
    );
  });
  const toggleCollapsed = () => {
    const next = !collapsed();
    setCollapsed(next);
    localStorage.setItem("sidenav_collapsed", String(next));
  };
  return (
    <div
      class="
        grid
        h-full
        grid-rows-[auto_1fr]
        grid-cols-[64px_1fr]
      "
    >
      <div
        class="
          col-span-2
          bg-slate-50/80 backdrop-blur-sm
          border-b border-slate-200
          px-1 py-1
          sticky top-0 z-20            /* stays visible while scrolling */
        "
      >
        {props.banner}
      </div>
      <div class="overflow-y-auto w-16">
        <SideNav
          active={props.active}
          onSelect={props.onSelect}
          extra={props.sidebarExtra}
          collapsed={collapsed()}
          onToggleCollapse={toggleCollapsed}
          onCaseInfoClick={props.onCaseInfoClick}
        />
      </div>
      <main class="px-2.5 py-2 space-y-6 overflow-y-auto">
        {props.children}
      </main>
      <TemplatesModal
        isOpen={showTemplates()}
        onClose={() => setShowTemplates(false)}
      />
    </div>
  );
}
